export const CHATGPT_IMAGE_REQUEST = 'CHATGPT_IMAGE_REQUEST';
export const CHATGPT_IMAGE_SUCCESS = 'CHATGPT_IMAGE_SUCCESS';
export const CHATGPT_IMAGE_FAIL = 'CHATGPT_IMAGE_FAIL';
export const CHATGPT_IMAGE_DELETE = 'CHATGPT_IMAGE_DELETE';
export const STYLING_LIST_REQUEST = 'STYLING_LIST_REQUEST';
export const STYLING_LIST_SUCCESS = 'STYLING_LIST_SUCCESS';
export const STYLING_LIST_FAIL = 'STYLING_LIST_FAIL'